export default {
  "button": "_button_4ohn0_5",
  "skeleton": "_skeleton_4ohn0_53",
  "primary": "_primary_4ohn0_58",
  "merge": "_merge_4ohn0_59",
  "success": "_success_4ohn0_60",
  "danger": "_danger_4ohn0_61",
  "upgrade": "_upgrade_4ohn0_62",
  "warning": "_warning_4ohn0_63",
  "user-primary": "_user-primary_4ohn0_103",
  "user-secondary": "_user-secondary_4ohn0_116",
  "secondary": "_secondary_4ohn0_132",
  "blank": "_blank_4ohn0_215",
  "nested": "_nested_4ohn0_216",
  "active": "_active_4ohn0_233",
  "inverted": "_inverted_4ohn0_239",
  "link": "_link_4ohn0_248",
  "pill": "_pill_4ohn0_267",
  "close": "_close_4ohn0_301",
  "xsmall": "_xsmall_4ohn0_314",
  "small": "_small_4ohn0_319",
  "medium": "_medium_4ohn0_324",
  "large": "_large_4ohn0_329",
  "xlarge": "_xlarge_4ohn0_334",
  "disabled": "_disabled_4ohn0_361"
};import "ni:sha-256;Qp6pwP975NEQMP9J5jG7MAV7a9wtCJI6P9EHIryvoqA";